import axios from 'axios'
import { getErrorCodeFromResponse } from 'src/utils/error'

export default ({ router, store }) => {
  axios.interceptors.response.use(response => response, error => {
    if (getErrorCodeFromResponse(error) === 'SUBSCRIPTION_REQUIRED') {
      router.replace({ name: 'team-settings', params: { teamId: store.getters.activeTeam.id }, query: { tab: 'subscription' } })
    }

    return Promise.reject(error)
  })
}
